import Nav from "../../general/nav.jsx";
import HeroFooter from "../../general/heroFooter.jsx";
import Imghero from "../../../assets/img/projects/Maison_Sambin/Logo.svg";
import { useTranslation } from "react-i18next";

function Hero() {
  const { t } = useTranslation();

  return (
    <div className="Maison_Sambin hero" id="hero">
      <Nav />
      <img className="ImgHero" src={Imghero} alt="Maison Sambin Hero" />
      <HeroFooter
        name={t("maisonSambin.hero.name")}
        link1url="https://maisonsambin.com/"
        link2display={false}
        link2name={t("maisonSambin.hero.link2")}
        link2url=""
      />
    </div>
  );
}

export default Hero;
